import { Box, Typography } from '@mui/material';
import {
  ArrowUp,
  Chats,
  ImageBroken,
  Info,
  Plus,
  X,
} from '@phosphor-icons/react';
import storeThemeChat from '../../../store/storeThemeChat';

export function PreviewChatbot() {
  const theme = storeThemeChat();

  const logo = theme.logo === '' ? null : theme.logo;
  const favIcon = theme.favicon === '' ? null : theme.favicon;
  const chatImage = theme.chatImage === '' ? null : theme.chatImage;
  const backgroundImage = theme.backgroundImage === '' ? null : theme.backgroundImage;
  const iconShape =
    theme.iconShape === '' || theme.iconShape === 'square' ? '3px' : '99px';
  const iconSize =
    theme.iconSize === '' || theme.iconSize === null ? 16 : theme.iconSize;

  const complementaryColor = theme.defaultTheme.toString().includes('dark')
    ? '#344054'
    : '#EAECF0';

  return (
    <Box display="flex" flexDirection="column" height="100%" gap="8px">
      <Box
        display="flex"
        flexDirection="column"
        borderRadius="4px 4px 0px 0px"
        border="1px solid #DEE1E6"
        bgcolor={theme.pageBackground}
        sx={{
          backgroundImage: backgroundImage
            ? `url(${backgroundImage})`
            : '',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          display="flex"
          bgcolor="#DEE1E6"
          alignItems="center"
          gap="16px"
          p="8px"
          borderRadius="4px 4px 0px 0px"
        >
          <Box display="flex" alignItems="center" gap="8px">
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: '#E14942',
              }}
            />
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: '#E1A325',
              }}
            />
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: '#3EAF3F',
              }}
            />
          </Box>

          <Box
            display="flex"
            gap="8px"
            padding="8px"
            bgcolor="#fff"
            borderRadius="8px 8px 0px 0px"
          >
            {favIcon !== null ? (
              <img
                src={favIcon}
                alt="favicon"
                style={{ width: '16px', height: '16px', objectFit: 'cover' }}
              />
            ) : (
              <ImageBroken size={16} />
            )}

            <Typography sx={{ fontSize: '12px', fontWeight: '400' }}>
              Company Name
            </Typography>

            <X size={16} />
          </Box>

          <Plus size={20} />
        </Box>

        <Box width="100%" height="6px" bgcolor={theme.brandColor} />

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p="16px"
          bgcolor={theme.userContainer}
        >
          {logo !== null ? (
            <img
              src={logo}
              alt="logo"
              style={{
                width: '100px',
                height: '33px',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              p="8px"
              borderRadius="8px"
              bgcolor={theme.inputBorderColor}
            >
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '400',
                  color: theme.pageText,
                }}
              >
                Logo goes here
              </Typography>
            </Box>
          )}

          <Box display="flex" gap="8px">
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: complementaryColor,
              }}
            />

            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: complementaryColor,
              }}
            />

            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: complementaryColor,
              }}
            />
          </Box>
        </Box>

        <Box display="flex" flexDirection="column" padding="16px" gap="10px">
          <Box bgcolor={theme.userContainer} padding="16px" borderRadius="8px">
            <Typography
              color={theme.userText}
              fontSize="16px"
              fontWeight={theme.fontWeight}
              fontFamily={theme.font}
            >
              This preview shows how the logos will display on the final
              interface.
            </Typography>
          </Box>

          <Box
            display="flex"
            alignItems="start"
            justifyContent="space-between"
            gap="10px"
          >
            <Box
              bgcolor={theme.brandColor}
              p="8px"
              display="flex"
              alignItems="center"
              borderRadius={iconShape}
            >
              {chatImage !== null ? (
                <img
                  src={chatImage}
                  alt="icon"
                  style={{
                    width: iconSize,
                    height: iconSize,
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Chats size={iconSize} style={{ color: '#fff' }} />
              )}
            </Box>

            <Box
              bgcolor={theme.responseContainer}
              padding="16px"
              borderRadius="8px"
            >
              <Typography
                color={theme.responseText}
                fontSize="16px"
                fontWeight={theme.fontWeight}
                fontFamily={theme.font}
              >
                This preview shows how the logos will display on the final
                interface.
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            border={`1px solid ${complementaryColor}`}
            padding="10px 8px 10px 8px"
            bgcolor={theme.userContainer}
            alignItems="center"
            borderRadius="3px"
            marginTop="16px"
          >
            <Typography sx={{ fontSize: '16px', color: theme.userText }}>
              Type here..
            </Typography>

            <Box
              bgcolor={theme.brandColor}
              padding="3px 5px"
              borderRadius="3px"
            >
              <ArrowUp size={16} color="#fff" />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box display="flex" gap="4px" alignItems="start">
        <Info size={24} />
        <Typography fontSize="12px" fontWeight="400" color="#475467">
          This is a preview to show how the final interface will look based on
          your changes.
        </Typography>
      </Box>
    </Box>
  );
}
